import { Injectable, inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class DashboardGuard {
  private auth = inject(AuthService)
  private router = inject(Router)

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.customer()) {
      if (this.auth.isNewCustomer) {
        return this.auth.isSetupRequired() ? this.router.parseUrl('/dashboard-visa/setup') : true
      } else {
        return this.router.parseUrl('/mypages/home')
      }
    }
    return this.router.parseUrl('/dashboard-visa/login')
  }
}
